import { AxiosResponse } from "axios";
import { Command, HttpVerbType, API_PREFIX, API_VERSION } from "../Command";
import { ServiceResponseData } from "../ServiceResponseData";
import { FetchWindowsGruoupsResponse } from "./FetchWindowsGroupsResponse";

const ENDPOINT = "/usermanagement/any_auth_plugin";

export class GetAnyAuthPluginCommand extends Command {
    endPoint: string = API_PREFIX + API_VERSION + ENDPOINT;
    httpVerb: HttpVerbType = "get";

    constructor() {
        super();
    }

    public async execute(): Promise<GetAnyAuthPluginResData> {
        var res = await this.executeCommand();
        return new GetAnyAuthPluginResData(res);
    }
}

export class GetAnyAuthPluginResData extends ServiceResponseData {
    any: boolean = false;

    constructor(response: AxiosResponse) {
        super(response);
        // console.log("response", response);
        if (response && response.data.Payload) {
            this.any = response.data.Payload.Any;
        }
    }
}
